import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const PopularDestinationsModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "mlp-popular-destinations" */
            './'
        )
    ),
    componentName: 'PopularDestinations',
    placeholder: {
        cardType: 'CardType1',
        placeholderType: 'Carousel',
        size: 'md',
    },
});
export default PopularDestinationsModule;
